module.exports = __webpack_public_path__ + "img/campaign_02.974430d5.png";